import { _SET_RESPONSE } from "~/store/item-category/mutations"

export const CATEGORY_ITEMS = "categoryItems"

export default {
  [CATEGORY_ITEMS]({ state, commit }, categoryParams) {
    commit(_SET_RESPONSE, categoryParams)
  }
}
